import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import DstButton from "../../../../components/DstButton/DstButton";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { AddDemoRecordPopupProps, FormType, initForm } from "./AddDemoRecordPopup.d";
import { submitDemoRecord, updateFormField } from "./AddDemoRecordPopup.function";

const AddDemoRecordPopup = ({ show, onClose, language, author_id, onSuccess }: AddDemoRecordPopupProps) => {
  const [form, setForm] = useState<FormType>(initForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (author_id) {
      setForm((prev) => ({ ...prev, author_id }));
    }
  }, [author_id]);

  return (
    <Popup
      show={show}
      onClose={onClose}
      modalTitle={translate(language, "PAGES.DEV.ADD_RECORD.FORM.TITLE")}
      size="lg"
      scrollable
      footerContent={
        <div className="d-flex justify-content-end gap-2">
          <DstButton
            value={translate(language, "PAGES.DEV.ADD_RECORD.FORM.CANCEL")}
            variant="secondary"
            clickFunction={onClose}
          />
          <DstButton
            value={translate(language, "PAGES.DEV.ADD_RECORD.FORM.SAVE")}
            clickFunction={() =>
              submitDemoRecord(form, language, setLoading, () => {
                setForm({ ...initForm, author_id });
                onClose();
                onSuccess();
              })
            }
            disabled={loading || !form.name.trim()}
            loading={loading}
          />
        </div>
      }
    >
      <Form className="m-regular">
        <Form.Group className="mb-3">
          <Form.Label>
            {translate(language, "PAGES.DEV.ADD_RECORD.FORM.NAME")} <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={form.name}
            onChange={(event) => updateFormField(event, setForm)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>{translate(language, "PAGES.DEV.ADD_RECORD.FORM.DESCRIPTION")}</Form.Label>
          <Form.Control
            as="textarea"
            name="description"
            rows={3}
            value={form.description}
            onChange={(event) => updateFormField(event, setForm)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>{translate(language, "PAGES.DEV.ADD_RECORD.FORM.DOCUMENTS_LINK")}</Form.Label>
          <Form.Control
            type="text"
            name="documents_link"
            value={form.documents_link}
            onChange={(event) => updateFormField(event, setForm)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>{translate(language, "PAGES.DEV.ADD_RECORD.FORM.RECORD_LINK")}</Form.Label>
          <Form.Control
            type="text"
            name="record_link"
            value={form.record_link}
            onChange={(event) => updateFormField(event, setForm)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>{translate(language, "PAGES.DEV.ADD_RECORD.FORM.SLIDE_LINK")}</Form.Label>
          <Form.Control
            type="text"
            name="slide_link"
            value={form.slide_link}
            onChange={(event) => updateFormField(event, setForm)}
          />
        </Form.Group>
      </Form>
    </Popup>
  );
};

export default AddDemoRecordPopup;
